import { Component, OnInit } from '@angular/core';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.scss']
})
export class ServiceHistoryComponent implements OnInit {
  constructor(public serviceLaneFacade: ServiceLaneFacade) {}

  ngOnInit() {
    this.serviceLaneFacade.serviceHistory$.subscribe(d => {
      console.log(d);
    });
  }
}
